import FasterEvent from '../fasterEvent'

export default new FasterEvent(
  { id: 'sign_in', revision: 0 },
  (eventBuilder, parameters) => {
    return eventBuilder
      .dimension('accountId', parameters.accountId)
      .dimension('method', parameters.method)
      .build()
  }
)
